import type { TenantAdminMenuItem } from "../types";

/** Menu administration tenant unifié — partagé entre RH, Edu, Inventory, Suite. */
export const TENANT_ADMIN_MENU_ITEMS: TenantAdminMenuItem[] = [
  {
    id: "users",
    labelKey: "menu.item.tenantUsers",
    path: "/tenant/users",
    icon: "users-group",
    permissions: ["user.read"],
    roles: ["TENANT_ADMIN", "PLATFORM_OWNER", "PLATFORM_ADMIN"],
  },
  {
    id: "roles",
    labelKey: "menu.item.tenantRoles",
    path: "/tenant/roles",
    icon: "user-star",
    permissions: ["role.read"],
    roles: ["TENANT_ADMIN", "PLATFORM_OWNER", "PLATFORM_ADMIN"],
  },
  {
    id: "module-access",
    labelKey: "menu.item.tenantModuleAccess",
    path: "/tenant/admin/module-access",
    icon: "layout-grid",
    permissions: ["user.update"],
    roles: ["TENANT_ADMIN", "PLATFORM_OWNER", "PLATFORM_ADMIN"],
  },
  {
    id: "sites",
    labelKey: "menu.item.tenantSites",
    path: "/tenant/admin/sites",
    icon: "building",
    permissions: ["organization.read"],
    roles: ["TENANT_ADMIN", "PLATFORM_OWNER", "PLATFORM_ADMIN"],
  },
  {
    id: "provisioning",
    labelKey: "menu.item.tenantProvisioning",
    path: "/tenant/admin/provisioning",
    icon: "package",
    permissions: ["settings.manage"],
    roles: ["TENANT_ADMIN", "PLATFORM_OWNER", "PLATFORM_ADMIN"],
  },
  {
    id: "invitations",
    labelKey: "menu.item.invitations",
    path: "/tenant/invitations",
    icon: "mail-forward",
    permissions: ["invitation.read"],
    roles: ["TENANT_ADMIN", "PLATFORM_OWNER", "PLATFORM_ADMIN"],
  },
];
